import { useEffect, useRef } from 'react'
import { HEYIMMO_WIDGET_URL } from '../../../config'
import './HeyImmo.css'
import { getLogger } from '../../../services/logger/logger'
import { useFeatureSwitch } from '../../../utils/features/FeatureSwitchContext'
import { FeatureSwitch } from '../../../utils/features/featureSwitches'
import { useAppSelector } from '../../../app/hooks'
import { InitState } from '../../../redux/reducers/root/initialState'

const SCRIPT_ID = 'heyimmo-widget-script'
const logger = getLogger('HeyImmo')

/**
 * HeyImmo ChatBot widget component
 * Loads the widget script and provides the mount point
 */
export const HeyImmo = () => {
  const { isActive: isHeyImmoEnabled } = useFeatureSwitch(FeatureSwitch.PPA_12798_HEYIMMO)
  const hasHeyImmo = useAppSelector((state: InitState) => state.flowFeature.flow?.flowInformation.options?.hasHeyImmo)
  const loadAttempted = useRef(false)
  const shouldRender = isHeyImmoEnabled && hasHeyImmo

  useEffect(() => {
    if (!shouldRender || !HEYIMMO_WIDGET_URL || loadAttempted.current) {
      return
    }

    loadAttempted.current = true

    // Check if script already exists
    if (document.getElementById(SCRIPT_ID)) {
      return
    }

    const script = document.createElement('script')
    script.id = SCRIPT_ID
    script.src = HEYIMMO_WIDGET_URL
    script.async = true

    script.onerror = () => {
      logger.error('Failed to load HeyImmo widget script', { url: HEYIMMO_WIDGET_URL })
    }

    document.body.appendChild(script)
  }, [shouldRender])

  if (!shouldRender) {
    return null
  }

  return <div id='ai-chat-bot' data-testid='ai-chat-bot' />
}
